import initialState from "AppCore/Store/initialState";
import Constants from "AppCore/Constants";

const { REDUCER: C } = Constants;


export default (state = initialState.locations, action) => {
	switch (action.type) {
	case C.SET_LOCATIONS:
		return {
			...state,
			...action.locations,
			loaded: true
		};
	case C.CLEAR_LOCATIONS:
		return initialState.locations;
	default:
		return state;
	}
}